export function JsnodeCo(props){

    const val1 = "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege";
    const val2 = "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev";
    const val3 = "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech";
    const val4 = "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org";
    const val5 = "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode";
    const val6 = "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org";
    const val7 = "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical";
    const val8 = "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya";
    const val9 = "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege";
    const val10 ="https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech";
    
    
    
        return (
    
            <>
    
            <h1 className="html_yt_heading">These are the <strong style={{textDecoration : 'underline', color : 'blue'}}>Top 10</strong>  Youtube Playlists That You can Refer  </h1>
    
    
            <h4 className="des_yt_html">
            
                1. Dive Into The Main Concepts <br/>
                2. Animation Explanations with real world Examples <br/>
                3. Important with Note Clarification.
                </h4>
            {/* <-----------------------------------------1------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid"> 1. Mera College
    
                {/* <strong style={{marginLeft : '40px', marginRight : '40px' ,border: '1px solid black', padding : '9px' , borderRadius: '7px', fontSize : '17px'
                }}> HTML</strong> 4.7 &#9733; &#9733; &#9733; &#9733;
                */}
    
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val1, "_blank")}>  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
                {/* <-----------------------------------------2------------------------------------------*/}
    
            <div className="container_html_yt_links">
    
                <p className="vid">
                2.SuperSimpleDev ( Highly Recommended )
    
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val2, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
                {/*  <-----------------------------------------3------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                3.PW Skills Tech
                     
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val3, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
                {/*  <-----------------------------------------4------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                     4. SuperSimpleDev 
    
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val4, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
    
            {/*  <-----------------------------------------5------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                5.Bro Code    
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val5, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
                {/*  <-----------------------------------------6------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                6.FreeCodeCamp
                     
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val6, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
                {/*  <-----------------------------------------7------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                7.Thapa Technical (Recommended) 
                    
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val7, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
                {/*  <-----------------------------------------8------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                8. Anuj Bhaiya ( TailWind CSS )
                      
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val8, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
            { /*  <-----------------------------------------9------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid">
                9.Apna College ( Recommended ) 
                  
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val9, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
        {/*  <-----------------------------------------10------------------------------------------*/}
            <div className="container_html_yt_links">
    
                <p className="vid"> 
                10. Ws Cube Tech (TailWind CSS)  
                   
                
                <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val10, "_blank")} >  Click Me </button>  
    
                </p>
            <p>
                </p>
    
            </div>
    
            </>
        )
    }
    
    export default JsnodeCo;